const ProfilePic = (props) => {
  const {
    url,
    name,
    alt
  } = props
  return ( <
    img id = "ProfilePic"
    src = {
      url
    }
    alt = {
      alt
    }
    />
  )
}

export default ProfilePic;
